import toast from 'react-hot-toast';
import api from '../Crypto/axios.js';

export const FETCH_ALL_HOMESLIDE = 'FETCH_ALL_HOMESLIDE';
export const ADD_NEW_HOMESLIDE = 'ADD_NEW_HOMESLIDE';
export const SET_SELECTED_HOMESLIDE_ROW = 'SET_SELECTED_HOMESLIDE_ROW';
export const RESET_SELECTED_HOMESLIDE_ROW = 'RESET_SELECTED_HOMESLIDE_ROW';
export const CLEAR_DATA = 'CLEAR_DATA';
export const STATUS_UPDATED = 'STATUS_UPDATED';
export const FETCH_ALL_HOMESLIDE_ONLY = 'FETCH_ALL_HOMESLIDE_ONLY';

const initialState = {
  allHomeSlide: [],
  allHomeSlidesOnly: [],
  newHomeSlide: [],
  selectedHomeSlideRow: {},
  statusUpdate: {},
};

const HomeSlideReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_HOMESLIDE:
      return {
        ...state,
        allHomeSlide: action.payload,
      };
    case FETCH_ALL_HOMESLIDE_ONLY:
      return {
        ...state,
        allHomeSlidesOnly: action.payload,
      };
    case ADD_NEW_HOMESLIDE:
      return {
        ...state,
        newHomeSlide: action.payload,
      };
    case SET_SELECTED_HOMESLIDE_ROW:
      return {
        ...state,
        selectedHomeSlideRow: action.payload,
      };
    case RESET_SELECTED_HOMESLIDE_ROW:
      return {
        ...state,
        selectedHomeSlideRow: {},
      };
    case STATUS_UPDATED:
      return {
        ...state,
        statusUpdate: {},
      };
    case CLEAR_DATA:
      return {
        ...state,
        selectedHomeSlideRow: {},
        error: null,
      };
    default:
      return state;
  }
};
export default HomeSlideReducer;

export const fetchAllHomeSlide = (data) => ({
  type: FETCH_ALL_HOMESLIDE,
  payload: data,
});
export const fetchAllHomeSlideOnly = (data) => ({
  type: FETCH_ALL_HOMESLIDE_ONLY,
  payload: data,
});
export const addNewHomeSlide = (data) => ({
  type: ADD_NEW_HOMESLIDE,
  payload: data,
});
export const clearData = () => ({
  type: CLEAR_DATA,
});
export const setSelectedHomeSlideRow = (data) => ({
  type: SET_SELECTED_HOMESLIDE_ROW,
  payload: data,
});
export const resetSelectedHomeSlideRow = () => ({
  type: RESET_SELECTED_HOMESLIDE_ROW,
  // payload: data,
});
export const statusUpdate = (data) => ({
  type: STATUS_UPDATED,
});

export const getAllHomeSlide = (adminId) => {
  return async (dispatch) => {
    const promise = api
      .get(`/nrcb/ecom/get/slide/${adminId}`, { requiresAuth: true })
      .then((response) => {
        dispatch(fetchAllHomeSlide(response));
        return response;
      });
    return promise.catch(() => {
      return { status: 'error', message: 'Failed to fetch home slides' };
    });
  };
};

export const addHomeSlide = (adminId, newSlide) => {
  return async (dispatch) => {
    const promise = (async () => {
      try {
        const response = await api.post(
          `/nrcb/ecom/new/slide/${adminId}`,
          newSlide,
          {
            requiresAuth: true,
            headers:
              newSlide instanceof FormData
                ? { 'Content-Type': 'multipart/form-data' }
                : { 'Content-Type': 'application/json' },
          }
        );
        dispatch(addNewHomeSlide(response));
        return response;
      } catch (error) {
        console.error('Error in add new Home Slide:', error);
        throw new Error(error?.message || 'Failed to add Home Slide');
      }
    })();

    toast.promise(promise, {
      loading: 'Adding New Home Slide...',
      success: 'New Home Slide Added',
      error: (error) => error.message || 'Failed to add Home Slide',
    });

    return promise;
  };
};

export const statusHomeSlide = (data, adminId) => {
  return async (dispatch) => {
    let val;

    const promise = (async () => {
      try {
        const response = await api.post(
          `/nrcb/ecom/status/slide/${adminId}`,
          data,
          { requiresAuth: true }
        );
        val = response;
        dispatch(statusUpdate(response));
        return response;
      } catch (error) {
        console.error('Error:', error);
        throw new Error(error?.message || 'Failed');
      }
    })();

    toast.promise(promise, {
      loading: 'Processing...',
      success: () => `Home slide : ${val?.message}`,
      error: (error) => error?.message || 'Failed',
    });

    return promise;
  };
};

export const editHomeSlide = (adminId, updatedSlideFormData, slideId) => {
  return async (dispatch) => {
    const promise = (async () => {
      try {
        const response = await api.post(
          `/nrcb/ecom/edit/homeslide/${adminId}/${slideId}`,
          updatedSlideFormData,
          { requiresAuth: true }
        );
        dispatch(addNewHomeSlide(response));
        dispatch(resetSelectedHomeSlideRow());
        return response;
      } catch (error) {
        console.error('Error in editing home slide:', error);
        throw new Error(error?.message || 'Failed to edit Home Slide');
      }
    })();
    toast.promise(promise, {
      loading: 'Editing Home Slide...',
      success: 'Home Slide Updated',
      error: (error) => error.message || 'Failed to edit Home Slide',
    });

    return promise;
  };
};

export const getHomeSlideOnly = () => {
  return async (dispatch) => {
    try {
      const response = await api.get('/nrcb/ecom/get/slideonly');
      if (!response) {
        throw new Error('Failed to get Home Slide');
      }
      dispatch(fetchAllHomeSlideOnly(response));
      return response;
    } catch (error) {
      if (error?.response?.status === 404) {
        dispatch(clearData());
      }
      // throw error;
    }
  };
};
